<script setup>
import { Popover, PopoverButton, PopoverPanel } from "@headlessui/vue";
import { ChevronUpIcon } from "@heroicons/vue/20/solid";

const props = defineProps({
  labelClass: {
    type: String,
    default: "",
  },
  label: {
    type: String,
    default: "",
  },
  options: {
    type: Object,
    default: () => {},
  },
});
</script>
<template>
  <Popover v-slot="{ open }" class="relative">
    <PopoverButton
      class="inline-flex items-center gap-x-1 outline-none focus:ring-0"
    >
      <span
        class="font-montserrat non-italic font-semibold text-base leading-10 text-15p"
        :class="props.labelClass"
        >{{ label }}</span
      >
      <ChevronUpIcon
        class="h-5 w-5"
        :class="{ 'rotate-180 transform': !open }"
        aria-hidden="true"
      />
    </PopoverButton>

    <transition
      enter-active-class="transition ease-out duration-200"
      enter-from-class="opacity-0 translate-y-1"
      enter-to-class="opacity-100 translate-y-0"
      leave-active-class="transition ease-in duration-150"
      leave-from-class="opacity-100 translate-y-0"
      leave-to-class="opacity-0 translate-y-1"
    >
      <PopoverPanel class="font-montserrat border-b-3 border-gray-10">
        <div
          class="w-screen max-w-max flex-auto bg-white text-15p leading-6 md:shadow-sm"
        >
          <div v-for="item in options" :key="item.name" class="relative p-4">
            <a
              :href="item.href"
              class="font-medium text-indigo-base capitalize"
            >
              {{ item.name }}
              <span class="absolute inset-0" />
            </a>
          </div>
        </div>
      </PopoverPanel>
    </transition>
  </Popover>
</template>
